import {
  FlexProps,
  StackProps,
  TabsProps,
  TabListProps,
  TabProps,
  TabPanelsProps,
  TabPanelProps,
  BoxProps,
  CenterProps,
  ImageProps,
  TextProps,
} from "@chakra-ui/react";

import { CSSProperties } from "react";

type StyleOnly<T> = Omit<T, "children">;

export const fullColumnFlex: FlexProps = {
  direction: "column",
  h: "full",
  w: "full",
};

export const fullCenteredVStack: StackProps = {
  p: "5",
  pb: "4",
  mb: "2",
  w: "full",
  h: "full",
  align: "center",
};

export const fullRelativeTabs: StyleOnly<TabsProps> = {
  h: "full",
  w: "full",
  pos: "relative",
  variant: "unstyled",
};

export const tabListSpacing: StyleOnly<TabListProps> = {
  pb: "4",
  pt: "3",
};

export const centeredBorderTopFlex: StyleOnly<FlexProps> = {
  h: "0",
  w: "full",
  pos: "absolute",
  alignSelf: "center",
  justifySelf: "center",
  borderTop: "1px solid #2A0F74",
  zIndex: 0,
};

export const styledTab: StyleOnly<TabProps> = {
  px: 4,
  py: 2,
  mr: 6,
  zIndex: 1,
  border: "1px solid #2A0F74",
  fontSize: "xs",
  borderRadius: "8px",
  bgColor: "#6c40f6",
  _selected: {
    bgColor: "#2A0F74",
    fontWeight: "700",
  },
  _focus: {
    boxShadow: "none",
  },
};

export const fadedSpan: CSSProperties = {
  opacity: 0.5,
  paddingRight: "10px",
};

export const fullTabPanels: StyleOnly<TabPanelsProps> = {
  h: "full",
  w: "full",
  py: 0,
};

export const fullTabPanel: StyleOnly<TabPanelProps> = {
  h: "full",
  w: "full",
};

export const spacedFullVStack: StyleOnly<StackProps> = {
  w: "full",
  h: "full",
  justifyContent: "space-between",
};

export const fullColumnCenteredFlex: StyleOnly<FlexProps> = {
  h: "full",
  w: "full",
  flex: "1",
  align: "center",
  direction: "column",
};

export const fullMaxTabPanel: StyleOnly<TabPanelProps> = {
  w: "full",
  h: "full",
  maxH: "full",
};

export const bgContainCenterBox: StyleOnly<BoxProps> = {
  bgRepeat: "no-repeat",
  bgSize: "contain",
  bgPos: "center",
  borderRadius: "xl",
  h: "full",
  w: "full",
};

export const imageCenterBase: StyleOnly<CenterProps> = {
  mx: "2",
  mb: "3",
  pos: "relative",
  bgColor: "white",
  borderWidth: "4px",
  borderRadius: "xl",
  marginBottom: "unset",
};

export const centeredOuterFlex: StyleOnly<FlexProps> = {
  h: "full",
  w: "full",
  justify: "center",
  overflow: "hidden",
  pos: "relative",
};

export const taskImageContainer: StyleOnly<FlexProps> = {
  w: "60%",
  h: "45vh",
  justify: "center",
  background: "white",
  borderRadius: "20px",
  margin: "0 auto",
  alignSelf: "center",
};

export const scaledImage: StyleOnly<ImageProps> = {
  borderRadius: "8px",
  bg: "white",
  px: "2",
  py: "2",
  h: "full",
  style: {
    objectFit: "scale-down",
  },
  overflow: "auto",
};

export const fullCenter: StyleOnly<CenterProps> = {
  w: "full",
  h: "full",
};

export const wrappedCenterFlex: StyleOnly<FlexProps> = {
  w: "full",
  h: "full",
  alignItems: "center",
  wrap: "wrap",
};

export const fullVStack: StyleOnly<StackProps> = {
  w: "full",
  h: "full",
};

export const fullColumnAlignCenteredFlex: StyleOnly<FlexProps> = {
  h: "full",
  w: "full",
  flex: "1",
  align: "center",
  justify: "center",
  direction: "column",
};

export const fullCenteredVStackMinH: StyleOnly<StackProps> = {
  w: "full",
  h: "full",
  align: "center",
  flex: "1",
  minH: "0",
  minW: "0",
};

export const letterBox: BoxProps = {
  bg: "white",
  borderRadius: "16px",
  boxShadow: "md",
  w: "200px",
  h: "200px",
  display: "grid",
  placeItems: "center",
};
export const letterTile: TextProps = {
  fontSize: { base: "3xl", md: "80px" },
  fontFamily: '"Patrick Hand", "Comic Neue", "Baloo 2", "Charis SIL", "Gentium Plus", serif',
  fontWeight: "700",
  color: "pink.500",
};
export const letterHStackProps: StackProps = {
  spacing: { base: 3, md: 6 },
  justify: "center",
  align: "center",
  w: "full",
  flexWrap: { base: "wrap", md: "nowrap" },
};

export const fullVStackProps: StackProps = {
  p: "5",
  pb: "2",
  mb: "2",
  w: "full",
  h: "full",
  align: "center",
};
